<template>
	<c-dialog ref="dialog" title="推送渠道" height="50vh" button-name="关闭">
		<dl v-for="(group, i) in channelList" v-if="group.length" :key="i" class="list">
			<dt>{{i ? '靓机渠道：' : '暗拍渠道：'}}</dt>
			<dd>
				<ul>
					<li v-for="(item, j) in group" :key="j" class="flex-center">
						<p class="flex-grow">{{item.channel_name}}：￥{{item.sale_price}}</p>
						<span :style="{'color': channelStateText(item).cls}" @click="channelStateText(item).tip ? $message({message: channelStateText(item).tip}) : ''">
							{{channelStateText(item).text}}
							<i v-if="channelStateText(item).tip" class="tf">&#xe72b;</i>
						</span>
					</li>
				</ul>
			</dd>
		</dl>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				channelList: []
			}
		},

		methods: {
			open(data) {
				this.channelList = [
					data.filter(item => item.is_dark_auction == 1),
					data.filter(item => item.is_dark_auction == 2)
				];
				this.$refs.dialog.open();
			},

			channelStateText(channel) {
				const ss = channel.sync_state;
				const st = channel.sync_type;
				const ls = channel.listing_state;
				const opName = {1: '发布', 2: '上架', 3: '下架', 4: '调价', 5: '信息更新', 6: '售出下架', 7: '锁单下架', 8: '退货退款恢复'}[st] || '操作';
				/**业务终态优先于传输进度态（对齐 PC product_list.vue）：已售出/下单锁定是订单在本渠道落定的事实态，不被 sync 进度盖过*/
				if (ls === 4) {
					return { text: '已售出', tip: '', cls: '#19be6b' };
				}
				if (ls === 5) {
					return { text: '锁定中', tip: '', cls: '#e6a23c' };
				}
				if (ss === 1) {
					/**本地已下架且待推送的是下架类任务（售出/锁单/手动下架已先行置 listing_state=3）：如实展示已下架；
					 * 上架任务(st=2)除外——重新上架曾取消的暗拍待推送时 listing_state 仍停在 3（渠道侧真实态），此时应如实展示待推送（对齐 PC product_list.vue）*/
					if (ls === 3 && st !== 2) {
						return { text: '已下架', tip: '', cls: '#999' };
					}
					return { text: '待推送', tip: '', cls: '' };
				}
				if (ss === 2) {
					/**需审批渠道（转转严选）发布受理后停在同步中，后端将审核过程状态写入 sync_fail_reason（进入同步中时已清空旧值，非空即审核中），
					 * 界面直接展示「上架中，需质检」（对齐 PC product_list.vue），后端原始进展说明点击弹 message；无说明则回落通用「推送中」*/
					if (channel.sync_fail_reason) {
						return { text: '上架中，需质检', tip: channel.sync_fail_reason, cls: '#e6a23c' };
					}
					return { text: '推送中', tip: '正在' + opName, cls: '#e6a23c' };
				}
				if (ss === 4) {
					return { text: '推送失败', tip: opName + '失败：' + (channel.sync_fail_reason || ''), cls: '#999' };
				}
				const listingText = {1: '待上架', 2: '已上架', 3: '已下架'}[ls] || '-';
				const listingCls = ls === 2 ? '#19be6b' : '#999';
				return { text: listingText, tip: '', cls: listingCls };
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.list {
		padding: 0 .4rem;
		
		dt {
			margin: .5rem .02rem .3rem;
			font-size: .3rem;
			color: #666;
		}

		dd {
			li {
				position: relative;
				border: .02rem solid #F5F5F5;
				border-radius: .08rem;
				padding: 0 .22rem;
				overflow: hidden;
				line-height: .72rem;
				font-size: .3rem;
				color: #444;
				background: #F5F5F5;

				&:nth-child(n+2) {
					margin-top: .18rem;
				}
			}
		}
	}
</style>